export function getWeatherTranslation(description: string): string {
    switch (description.toLowerCase()) {
      case "clear sky":
        return "klarer Himmel";
      case "few clouds":
        return "wenige Wolken";
      case "scattered clouds":
        return "vereinzelte Wolken";
      case "broken clouds":
        return "aufgelockerte Wolken";
      case "overcast clouds":
        return "bedeckte Wolken";
      case "light rain":
        return "leichter Regen";
      case "moderate rain":
        return "mäßiger Regen";
      case "heavy intensity rain":
        return "starker Regen";
      case "very heavy rain":
        return "sehr starker Regen";
      case "extreme rain":
        return "extremer Regen";
      case "freezing rain":
        return "gefrierender Regen";
      case "light intensity shower rain":
        return "leichter Regenschauer";
      case "shower rain":
        return "Regenschauer";
      case "heavy intensity shower rain":
        return "starker Regenschauer";
      case "ragged shower rain":
        return "unregelmäßiger Regenschauer";
      case "thunderstorm":
        return "Gewitter";
      case "thunderstorm with light rain":
        return "Gewitter mit leichtem Regen";
      case "thunderstorm with rain":
        return "Gewitter mit Regen";
      case "thunderstorm with heavy rain":
        return "Gewitter mit starkem Regen";
      case "light thunderstorm":
        return "leichtes Gewitter";
      case "heavy thunderstorm":
        return "starkes Gewitter";
      case "ragged thunderstorm":
        return "unregelmäßiges Gewitter";
      case "thunderstorm with light drizzle":
        return "Gewitter mit leichtem Nieselregen";
      case "thunderstorm with drizzle":
        return "Gewitter mit Nieselregen";
      case "thunderstorm with heavy drizzle":
        return "Gewitter mit starkem Nieselregen";
      case "drizzle":
        return "Nieselregen";
      case "light intensity drizzle":
        return "leichter Nieselregen";
      case "drizzle rain":
        return "Nieselregen";
      case "heavy intensity drizzle":
        return "starker Nieselregen";
      case "light intensity drizzle rain":
        return "leichter Nieselregen";
      case "shower rain and drizzle":
        return "Regenschauer und Nieselregen";
      case "heavy intensity shower rain and drizzle":
        return "starker Regenschauer und Nieselregen";
      case "shower drizzle":
        return "Regenschauer-Nieselregen";
      case "snow":
        return "Schnee";
      case "light snow":
        return "leichter Schnee";
      case "heavy snow":
        return "starker Schnee";
      case "sleet":
        return "Schneeregen";
      case "light shower sleet":
        return "leichter Schneeregen";
      case "shower sleet":
        return "Schneeregen";
      case "light rain and snow":
        return "leichter Regen und Schnee";
      case "rain and snow":
        return "Regen und Schnee";
      case "light shower snow":
        return "leichter Schneeschauer";
      case "shower snow":
        return "Schneeschauer";
      case "heavy shower snow":
        return "starker Schneeschauer";
      case "mist":
        return "Nebel";
      case "smoke":
        return "Rauch";
      case "haze":
        return "Dunst";
      case "sand/dust whirls":
        return "Staubwirbel";
      case "fog":
        return "Nebel";
      case "sand":
        return "Sand";
      case "dust":
        return "Staub";
      case "volcanic ash":
        return "Vulkanasche";
      case "squalls":
        return "Böen";
      case "tornado":
        return "Tornado";
      default:
        return description;
    }
  }
  